'use client';

import * as DS from '@aurorasolar/ds';
import { x } from '@xstyled/styled-components';
import Link from 'next/link';
import { useState } from 'react';

import { CallButton, NavMenu, useCrossDomainHref } from '@/app/components';
import { PostSummary } from '@/app/home-solar/blog/actions';
import { AffiliateId } from '@/models';

type Props = { colorMode?: 'light' | 'dark'; featuredPosts?: PostSummary[] };

export const Header = ({ colorMode = 'light', featuredPosts = [] }: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);
  const homeHref = useCrossDomainHref('/', AffiliateId.AURORA_BLOG);

  const ModeProvider = colorMode === 'dark' ? DS.DarkModeProvider : DS.LightModeProvider;

  return (
    <ModeProvider>
      <NavMenu
        fallbackAffiliateId={AffiliateId.AURORA_BLOG}
        featuredPosts={featuredPosts}
        onClose={closeMenu}
        open={isMenuOpen}
      />
      <x.header bg={colorMode === 'dark' ? 'black' : 'white'} position="sticky" top={0} w="100%" zIndex={20}>
        <DS.Flex
          alignItems="center"
          flexDirection="row"
          justifyContent="space-between"
          maxW={DS.BorealisTheme.screens.xl}
          mx="auto"
          px={4}
          py={2}
        >
          {/* Logo goes to the quote homepage, not the aurorasolar.com (B2B) root */}
          <Link aria-label="Home" href={homeHref} prefetch={false} style={{ zIndex: 1 }}>
            <DS.IconLogo size={{ _: 5, md: 7 }} />
          </Link>
          <DS.Flex alignItems="center" flexDirection="row" flexShrink={1} w="auto">
            <CallButton compact variant="primary" />
            <DS.Button
              bg="transparent"
              borderWidth={0}
              icon={DS.IconMenu}
              iconProps={{ size: 6 }}
              onClick={() => setIsMenuOpen(true)}
              variant="secondary"
            />
          </DS.Flex>
        </DS.Flex>
      </x.header>
    </ModeProvider>
  );
};
